import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=72cc403d&scoped=true"
import script from "./Enroll.vue?vue&type=script&lang=js"
export * from "./Enroll.vue?vue&type=script&lang=js"
import style0 from "./Enroll.vue?vue&type=style&index=0&id=72cc403d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc403d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cc403d')) {
      api.createRecord('72cc403d', component.options)
    } else {
      api.reload('72cc403d', component.options)
    }
    module.hot.accept("./Enroll.vue?vue&type=template&id=72cc403d&scoped=true", function () {
      api.rerender('72cc403d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/enroll/Enroll.vue"
export default component.exports